module.exports = __webpack_public_path__ + "img/airport.2d74890b.jpg";